import React from 'react';
import {Container, Typography} from '@mui/material';
import { freeMeasurementsViewState } from '/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState';

export const TableOfContents = ({ closeDrawer }) => {
    const state = freeMeasurementsViewState;

    const loadSection = (slug) => {
        state.loadSection(slug);
        closeDrawer();
    }
    return (
        <Container maxWidth="md" sx={{ mt: 2 }}>
            {state.sections.map((section, index) => (
                <Typography
                    key={section.slug}
                    onClick={() => loadSection(section.slug)}
                    variant="body1"
                    gutterBottom
                    sx={{
                        cursor: 'pointer',
                        lineHeight: "1",
                        pt: 0.8,
                        pb: 0.8,
                }}
                >{section.name_ru}</Typography>
            ))}
        </Container>
    )
}
